import { useHotKeys } from 'Hooks'
import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import WeaverService from 'Services/WeaverService'
import { setEdits, setSelection, setSelectionType } from '../SpreadSheetDataProvider/actions'
import { emptyCell, selectionTypes } from '../helpers'

export default MultiRowSelectShortcuts = ->

  [{ columns, edits, selection }, dispatch] = useSpreadSheetData()

  useHotKeys([{
    sequence: ['down', 'enter']
    fn: ->
      dispatch(setSelectionType(selectionTypes.ROW))
      dispatch(setSelection(selection[1] + 1))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'up'
    fn: ->
      if selection[1] > 0
        dispatch(setSelectionType(selectionTypes.ROW))
        dispatch(setSelection(selection[1] - 1))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: ['right', 'tab']
    fn: ->
      dispatch(setSelection([0, selection[1]]))
      dispatch(setSelectionType(selectionTypes.CELL))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+up'
    fn: ->
      if selection[1] > 0
        dispatch(setSelection([selection[0], selection[1] - 1]))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+down'
    fn: ->
      dispatch(setSelection([selection[0], selection[1] + 1]))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'backspace'
    fn: ->
      newEdits = [selection[0]..selection[1]].reduce((acc, i) ->
        {
          acc...,
          [i]: ([0..(columns.length - 1)].reduce(((acc, j) ->
            {
              edits[i]...,
              acc...,
              [j]: emptyCell(columns[j])
            }
          ), {}))
        }
      , edits)
      dispatch(setEdits({
        prevEdits: edits
        nextEdits: newEdits
      }))
    temporary: true
    expr: WeaverService.userCanEdit()
    watchers: [selection, edits]
  }])

  <div />





